


























































































interface Shortcut {
  text: string
  from: string
  to: string
}

import Vue from 'vue'
import moment from 'moment'
import { isNumeric } from '@/utils/validation'

export default Vue.extend({
  name: 'DateTimePicker1Component',
  props: {
    value: Array,
  },
  data() {
    return {
      dpFrom: '',
      dpTo: '',
      from: 'now()-1h',
      to: 'now()',
      dtView: 'Last 30 minutes',
      popoverShow: false,
      shortcuts: [
        { text: 'Last 5 minutes', from: 'now()-5m', to: 'now()' },
        { text: 'Last 15 minutes', from: 'now()-5m', to: 'now()' },
        { text: 'Last 30 minutes', from: 'now()-5m', to: 'now()' },
        { text: 'Last 1 hour', from: 'now()-1h', to: 'now()' },
        { text: 'Last 2 hours', from: 'now()-2h', to: 'now()' },
        { text: 'Last 6 hours', from: 'now()-6h', to: 'now()' },
        { text: 'Last 12 hours', from: 'now()-12h', to: 'now()' },
        { text: 'Last 24 hours', from: 'now()-24h', to: 'now()' },
        { text: 'Last 7 days', from: 'now()-7d', to: 'now()' },
        { text: 'Last 30 days', from: 'now()-30d', to: 'now()' },
      ],
    }
  },
  methods: {
    onApply() {
      let from = 0
      let to = 0

      if (isNumeric(this.from)) {
        from = new Date(parseInt(this.from)).valueOf()
        this.from = moment(from).format('YYYY-MM-DD HH:mm:ss')
      } else {
        from = new Date(this.from).valueOf()
      }

      if (isNumeric(this.to)) {
        to = new Date(parseInt(this.to)).valueOf()
        this.to = moment(to).format('YYYY-MM-DD HH:mm:ss')
      } else {
        to = new Date(this.to).valueOf()
      }

      if (!isNaN(from) && !isNaN(to)) {
        this.$emit('input', [from.toString(), to.toString()])
        this.dtView = `${this.from} <strong class="mx-4">to</strong> ${this.to}`
      } else {
        this.$emit('input', [this.from, this.to])
      }
      this.popoverShow = false
      this.$emit('apply')
    },

    onShortcutClicked(s: Shortcut) {
      this.from = s.from
      this.to = s.to
      this.dtView = s.text

      this.onApply()
    },
  },

  watch: {
    dpFrom: function(value: string) {
      this.from = value + ' 00:00:00'
    },
    dpTo: function(value: string) {
      this.to = value + ' 23:59:59'
    },
  },

  created() {
    if (
      typeof this.$route.query.from == 'string' &&
      typeof this.$route.query.to == 'string'
    ) {
      let isShortcut = false
      for (const shortcut of this.shortcuts) {
        if (
          shortcut.from == this.$route.query.from &&
          shortcut.to == this.$route.query.to
        ) {
          this.onShortcutClicked(shortcut)
          isShortcut = true
          break
        }
      }

      if (!isShortcut) {
        this.onShortcutClicked({
          from: this.$route.query.from,
          to: this.$route.query.to,
          text: this.$route.query.from,
        })
      }
    } else {
      this.onShortcutClicked(this.shortcuts[3])
    }
  },
})
